import React from "react";
import { TradeInAemLabel, useTradeInAemLabel } from "../../../utils/labels";
import * as ResultStyles from "../common/styles/ResultsAem";
import { useTradeInAemSelector } from "../../../redux/store";

const ContactFormDealer = (): JSX.Element | null => {
    const dealer = useTradeInAemSelector((state) => state.tradeInAemDealer.dealer);
    const dealerAddressLabel = useTradeInAemLabel("tradeInAemContactDealerAddress", dealer?.address);

    if (!dealer) return null;

    return (
        <>
            <TradeInAemLabel label="tradeInAemContactFormYourRetailer" />
            <ResultStyles.Card>
                <ResultStyles.CardBody py={{ xs: 2, lg: 2 }}>
                    <ResultStyles.CardTitle mb={1}>{dealer.name}</ResultStyles.CardTitle>
                    <ResultStyles.CardAddress>{dealerAddressLabel.replace(/\\n/g, "\n")}</ResultStyles.CardAddress>
                </ResultStyles.CardBody>
            </ResultStyles.Card>
        </>
    );
};

export default ContactFormDealer;
